import { ThemeContext } from "@emotion/react"
import { Checkbox, Divider, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, Radio, RadioGroup, TextField, Typography } from "@mui/material"
import { useContext } from "react"


export const PreguntaResponse = ({ pregunta, seccion_index, pregunta_index, disabled = false, formdata, changeDataPregunta }) => {

  const theme = useContext(ThemeContext);

  const onChangeData = (field, value) => {
    changeDataPregunta(seccion_index, pregunta_index, field, value);
  }

  const typeText = () => {

    return (
      <TextField
        id={`res_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}
        name={`res_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}
        size="small"
        fullWidth
        multiline
        minRows={3}
        required
        disabled={disabled}
        defaultValue={pregunta.cupe_valorprellenado}
        error={!pregunta.cupe_valorprellenado && !pregunta.respuesta}
        onChange={(e) => onChangeData('respuesta', e.target.value)}
        sx={{ color: theme.palette.primary.input }}
      />
    )
  }
  const typeNumber = () => {

    return (
      <TextField
        id={`res_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}
        name={`res_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}
        size="small"
        type="number"
        fullWidth
        required
        disabled={disabled}
        defaultValue={+pregunta.cupe_valorprellenado}
        error={!pregunta.cupe_valorprellenado && (isNaN(pregunta.respuesta) || parseFloat(pregunta.respuesta) < 0)}
        onChange={(e) => onChangeData('respuesta', `${parseFloat(e.target?.value).toFixed(2)}`)}
        onBlur={(e) => formdata.current[`res_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`].value = parseFloat(e.target?.value).toFixed(2)}
        sx={{ color: theme.palette.primary.input }}
      />
    )
  }
  const typeRange = () => {

    const onChangeRango = (position, value) => {
      if (pregunta?.respuesta) {
        let valorPrellenado = pregunta.respuesta;
        valorPrellenado[position].value = value;
        console.log("valorPrellenado", valorPrellenado);
        onChangeData("respuesta", valorPrellenado);
      } else {
        let valorPrellenado = [
          { label: "min", value: null },
          { label: "max", value: null }
        ];
        valorPrellenado[position].value = value;
        onChangeData("respuesta", valorPrellenado);
      }
    }

    return (
      <Grid container spacing={0}>
        <Grid item xs={6} sx={{ p: 0, pr: 1, textAlign: 'center' }}>
          <TextField
            id={`res_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}_rango_min`}
            name={`res_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}_rango_min`}
            size="small"
            type="number"
            fullWidth
            required
            disabled={disabled}
            defaultValue={JSON.parse(pregunta.cupe_valorprellenado)[0].value}
            error={!JSON.parse(pregunta.cupe_valorprellenado)[0].value && !pregunta.respuesta[0]?.value}
            onChange={(e) => onChangeRango(0, e.target.value)}
            sx={{ color: theme.palette.primary.input }}
          />
        </Grid>
        <Grid item xs={6} sx={{ p: 0, pl: 1, textAlign: 'center' }}>
          <TextField
            id={`res_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}_rango_max`}
            name={`res_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}_rango_max`}
            size="small"
            type="number"
            fullWidth
            required
            disabled={disabled}
            defaultValue={JSON.parse(pregunta.cupe_valorprellenado)[1].value}
            error={!JSON.parse(pregunta.cupe_valorprellenado)[1].value && !pregunta.respuesta[1]?.value}
            onChange={(e) => onChangeRango(1, e.target.value)}
            sx={{ color: theme.palette.primary.input }}
          />
        </Grid>
      </Grid>
    )
  }
  const typeOptions = () => {

    const onChangeOptionUnique = (value) => {
      onChangeData("respuesta", +value);
    }

    const onChangeOptionMultiple = (value) => {
      if (pregunta?.respuesta) {
        let respuesta = pregunta.respuesta;
        if (respuesta.includes(value)) {
          respuesta = respuesta.filter(r => r !== value);
        } else {
          respuesta.push(value);
        }
        onChangeData("respuesta", respuesta);
      } else {
        onChangeData("respuesta", [value]);
      }
    }

    return (
      <>
        {
          pregunta.cupe_multiple === 0 && (
            <FormControl
              component="fieldset"
              variant="standard"
              id={`fc_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}
              required
              error={!pregunta.respuesta}
            >
              <FormLabel id={`fl_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}></FormLabel>
              <RadioGroup
                aria-labelledby={`fl_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}
                name={`res_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}
                disabled={disabled}
                onChange={(e) => onChangeOptionUnique(e.target.value)}
              >
                {
                  JSON.parse(pregunta.cupe_opciones)?.map((opcion, iOpcion) =>
                    <>
                      <FormControlLabel
                        key={`op_${iOpcion}_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}
                        value={opcion?.value}
                        control={<Radio />}
                        label={opcion.label}
                      />
                    </>
                  )
                }
              </RadioGroup>
            </FormControl>
          )
        }
        {
          pregunta.cupe_multiple === 1 && (
            <FormControl
              sx={{ m: 0 }}
              component="fieldset"
              variant="standard"
              required
              error={!pregunta.respuesta || pregunta?.respuesta?.length === 0}
              name={`fc_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}
              id={`fc_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}
              disabled={disabled}
            >
              <FormLabel component="legend"></FormLabel>
              <FormGroup id={`fg_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`} itemID={`fg_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`} >
                {
                  JSON.parse(pregunta.cupe_opciones)?.map((opcion) =>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(e) => onChangeOptionMultiple(opcion?.value)}
                        />
                      }
                      label={opcion.label}
                    />
                  )
                }
              </FormGroup>
            </FormControl>
          )
        }
      </>
    )
  }
  // const typeMediciones = () => {

  //   return (
  //     <>
  //       <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: ' space-around' }} >
  //         <Typography id="transition-modal-title" variant="h10" component="h3" sx={{ color: theme.palette.primary.input, fontSize: 14 }}>Minimo:</Typography>
  //         {!disabled &&
  //           <span style={{ fontSize: 14 }}>{Array.isArray(dataDefault) ? parseFloat(dataDefault?.find(d => d?.label === "min")?.value) : null}</span>}
  //         {disabled &&
  //           <span style={{ fontSize: 14 }}>{Array.isArray(opciones) ? parseFloat(opciones?.find(d => d?.label === "min")?.value) : null}</span>}
  //         <Typography id="transition-modal-title" variant="h10" component="h3" sx={{ color: theme.palette.primary.input, fontSize: 14 }}>Máximo:</Typography>
  //         {!disabled &&
  //           <span style={{ fontSize: 14 }}>{Array.isArray(dataDefault) ? parseFloat(dataDefault?.find(d => d?.label === "max")?.value) : null}</span>}
  //         {disabled &&
  //           <span style={{ fontSize: 14 }}>{Array.isArray(opciones) ? parseFloat(opciones?.find(d => d?.label === "max")?.value) : null}</span>}
  //       </div>
  //       <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }} >
  //         <Typography id="transition-modal-title" variant="h10" component="h3" sx={{ color: '#000000', fontSize: 14 }}>
  //           {standar}
  //         </Typography>
  //       </div>

  //       {cantidad > 0 &&
  //         <Grid container spacing={0}>
  //           {Array.from({ length: inputs }).map((_, index) => (
  //             <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ p: 1, mb: 1, display: 'flex', justifyContent: 'center', flexDirection: 'column' }} >
  //               <TextField
  //                 id={`${index}_estd`}
  //                 name={`${index}_estd`}
  //                 size="small"
  //                 type="number"
  //                 fullWidth
  //                 required
  //                 disabled={disabled}
  //                 defaultValue={resp !== undefined ? parseFloat((resp[index]))?.toFixed(2) : 25.00}
  //                 onBlur={(e) =>
  //                   validateRange(`${index}_estd`, e.target.value, id, index, e)
  //                 }
  //                 sx={{ color: theme.palette.primary.input }}
  //               />
  //             </Grid>

  //           ))}
  //         </Grid>
  //       }
  //     </>
  //   )
  // }
  // const typeMedicionesSE = () => {

  //   return (
  //     <>
  //       <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }} >
  //         <Typography id="transition-modal-title" variant="h10" component="h3" sx={{ color: '#000000', fontSize: 14 }}>
  //           Valores de referencia
  //         </Typography>
  //       </div>
  //       <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: ' space-around' }} >
  //         <Typography id="transition-modal-title" variant="h10" component="h3" sx={{ color: theme.palette.primary.input, fontSize: 14 }}>Minimo:</Typography>
  //         <span style={{ fontSize: 14 }}>{JSON.parse(pregunta?.cupe_valorprellenado)[0].value}</span>
  //         <Typography id="transition-modal-title" variant="h10" component="h3" sx={{ color: theme.palette.primary.input, fontSize: 14 }}>Máximo:</Typography>
  //         <span style={{ fontSize: 14 }}>{JSON.parse(pregunta?.cupe_valorprellenado)[1].value}</span>
  //       </div>
  //       <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: ' space-around' }} >
  //         <Typography id="transition-modal-title" variant="h10" component="h3" sx={{ color: theme.palette.primary.input, fontSize: 14 }}>Mediciones:</Typography>
  //         <span style={{ fontSize: 14 }}>{JSON.parse(pregunta?.cupe_valorprellenado)[2].value}</span>
  //         <Typography id="transition-modal-title" variant="h10" component="h3" sx={{ color: theme.palette.primary.input, fontSize: 14 }}>Muestra:</Typography>
  //         <span style={{ fontSize: 14 }}>{JSON.parse(pregunta?.cupe_valorprellenado)[3].value}</span>
  //       </div>
  //       <Divider sx={{ mb: 1 }} />
  //       {((JSON.parse(pregunta?.cupe_valorprellenado)[2].value > 0 && JSON.parse(pregunta?.cupe_valorprellenado)[3].value > 0)) &&
  //         <Grid container spacing={0}>
  //           {Array.from({ length: JSON.parse(pregunta?.cupe_valorprellenado)[2].value * JSON.parse(pregunta?.cupe_valorprellenado)[3].value }).map((_, index) => (
  //             <Grid item xs={12} sm={12} md={6} lg={6} xl={6} sx={{ p: 1, mb: 1, display: 'flex', justifyContent: 'center', flexDirection: 'column' }} >
  //               <TextField
  //                 id={`mse_${index}_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}
  //                 name={`mse_${index}_s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`}
  //                 size="small"
  //                 type="number"
  //                 fullWidth
  //                 required
  //                 disabled={disabled}
  //                 onBlur={(e) => {
  //                   const min = JSON.parse(pregunta?.cupe_valorprellenado)[0].value
  //                   const max = JSON.parse(pregunta?.cupe_valorprellenado)[1].value
  //                   const value = parseFloat(e.target.value);
  //                   if (value < min) {
  //                     e.target.value = min;
  //                   } else if (value > max) {
  //                     e.target.value = max;
  //                   }
  //                   // validateSinEstandar(`${index}_sinmuestra`, e.target.value, id, index, e)
  //                 }}
  //                 sx={{ color: theme.palette.primary.input }}
  //               />
  //             </Grid>
  //           ))}
  //         </Grid>
  //       }
  //     </>
  //   )
  // }



  const chooseType = () => {
    switch (parseInt(pregunta.cupe_tipo)) {
      case 1:
        return typeText();
      case 2:
        return typeNumber();
      case 3:
        return typeRange();
      case 4:
        return typeOptions();
      // case 5:
      //   return typeMediciones();
      // case 6:
      //   return typeMedicionesSE();
    }
  }

  return (
    <Grid item key={`s${seccion_index}_p${pregunta_index}_pi${pregunta.cupe_id}`} xs={12} sx={{ p: 0, pl: 2, pr: 2, textAlign: "justify" }} >
      <Grid container spacing={0}>
        <Grid item xs={12} sm={12} md={7} lg={7} xl={7} sx={{ p: 2, mb: 1, display: 'flex', justifyContent: 'center', flexDirection: 'column' }} >
          <Typography id="transition-modal-title" variant="h10" component="h3" sx={{ color: theme.palette.primary.input, fontSize: 16 }}>
            {pregunta.cupe_pregunta}
          </Typography>
          {
            pregunta?.cupe_descripcion &&
            <Typography
              id="transition-modal-title"
              variant="h11" component="h4"
              sx={{ color: theme.palette.primary.input, fontSize: 12 }}>
              {pregunta.cupe_descripcion}
            </Typography>
          }
        </Grid>
        <Grid item xs={12} sm={12} md={5} lg={5} xl={5} sx={{ p: 2, mb: 1, display: 'flex', justifyContent: 'center', flexDirection: 'column' }} >
          {
            pregunta?.cupe_tipo && chooseType()
          }
        </Grid>
      </Grid>
    </Grid>
  )
}